import * as yup from 'yup';

export const otp_schema = {
  otp: '',
};

export const otp_validation_schema = yup.object().shape({
  otp: yup.string().required('otp_required').min(4, 'invalid_otp'),
});
